import React, { Component } from 'react';
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import { Tab, Tabs } from 'material-ui/Tabs';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';
import moment from 'moment';
import { change, Field, FieldArray, reduxForm } from 'redux-form';

import { renderToggleButton, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderTimePicker, renderTextField, isFloat, isInteger } from '../../../../../components/reduxFields';
import { alertConfirmation } from '../../../../../actions/utilAction';
import SortingCustom from '../../../../../components/SortingCustom';
import PaginatorCustom from '../../../../../components/paginationCustom';


import { getSkillAcquisitionDomainList, getMasterData, deleteSkillAcquisitionDomain } from './components/Domain/actions/skillAquisitionDomainActions';
import { getSkillAcquisitionProgramList, deleteSkillAcquisitionProgram, updateProgramActiveStatus, copyPatientSkillAcquisitionProgram } from './components/Program/actions/skillAquisitionProgramActions';
import { getSkillAcquisitionTargetList, deleteSkillAcquisitionTarget, updateTargetActiveStatus, updateTargetStatus, copyPatientSkillAcquisitionTarget, saveSkillsAcquisitionRawData, SaveRawSkillAquisitionBehaviorData } from './components/Target/actions/skillAquisitionTargetActions'
import { getPatientSkillAcqTaskAnalysislist } from './../../collectData/componnets/SkillAquisition/components/targets/actions/targetsAction'

import SkillAquisitionDomainModal from './components/Domain/Add_Domain_Modal';
import BatchUnarchiveSkillAcquisitionModal from "./components/Domain/BatchUnarchiveSkillAcquisition_Modal";
import AddNewProgramModal from '../../../../MastersDataCollection/curriculumLibraries/components/program/program_Modal';
import ProgramFromLibraryModal from "./components/Program/programFromLibrary_Modal";
import { getProgramDetailsByDomain } from '../../../../MastersDataCollection/curriculumLibraries/components/program/actions/programActions';
import TargetModalCustom from './components/Target/skillAquisition_target_Modal';
import ProgramInstructionModal from "./components/Program/programInstruction_Modal";
import EditDomainModal from './components/Domain/EditDomainModal';
import RawDataDTTModal from './components/Target/RawDataDTTModal';
import RawDataTAModal from './components/Target/RawDataTAModal';
import RawDataSkillAquisitionBehaviorModal from './components/Target/RawDataModal';
import DTTGraphModal from './components/Target/DTTGraphModal/index';
import TAGraphModal from './components/Target/TAGraphModal/index';
import FrequencyGraphModal from './components/Target/FrequencyGraphModal/index';
import DurationGraphModal from './components/Target/DurationGraphModal/index';
import ProgramGraphModal from './components/Program/ProgramGraphModal/index';
import UpdateBatchTargetStatusModal from './UpdateBatchTargetStatusModal';
import UpdateBatchActiveStatusModal from './UpdateBatchActiveStatusModal';
import { CommonButton } from '../../../../../components/buttons';
import { clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { getPromptCodeList } from '../SetUp/promptCodes/actions/PromptCodeActions';
import { UpdateDCArchiveStatus } from '../../../../MastersDataCollection/curriculumLibraries/actions/CurriculumLibrariesActions';
import CopyCurriculumLibraryModal from './components/Domain/CopyCurriculumLibraryModal';
import MoveDomainModal from './components/Domain/MoveDomainModal';
import _ from 'lodash';

const innerTabStyles = {
    default_tab: {
        height: '40px',
        fontSize: '14px',
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.60)',
        border: '1px solid #ddd',
    },
    active_tab: {
        height: '37px',
        color: 'rgba(0, 0, 0, 0.80)',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
    },
};

const stylescss = {
    checkbox: {
        marginBottom: 16,
    },
};

class SkillAquisition extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            patientId: props.patientId,
            innerActiveTab: '0',
            skillAcquisitionDomainId: null,
            masterDomains: [],
            masterPrograms: [],
            domainData: [],
            openProgramFromLibrary: false,
            openNewProgram: false,
            openNewTarget: false,
            openProgramInstruction: false,
            programId: null,
            skillsAcquisitionProgramId: null,
            domainId: null,
            parentDomainId: null,
            isOnDomainClick: false,
            desiredDailyTrials: [],
            masteryType: [],
            autoOpenOrder: [],
            targetType: [],
            responsePercentage: [],
            consecutiveDays: [],
            firstTrialMustBeIndependent: [],
            dcMasterMaintenanceLevels: [],
            filteredDomain: [],
            filteredPrograms: [],
            isProgramClicked: false,
            isAddRawDataClicked: false,
            skillAquisitionTargetId: null,
            targetId: null,
            activeProgramToggleValues: [],
            activeTargetToggleValues: [],
            domainIdForDelete: '',
            isEditDomainClicked: false,
            rawDataDttModal: false,
            rawDataTAModal: false,
            addRawDataTAModal: false,
            ClickedTargetType: null,
            DTTGraphModalOpen: false,
            TAGraphModalOpen: false,
            FrequencyGraphModalOpen: false,
            DurationGraphModalOpen: false,
            ProgramGraphModalOpen: false,
            modalTitle: '',
            targetType: '',
            selectedSkillsAcquisitionTargetIds: [],
            openBatchTargetStatusModal: false,
            sessionDate: [],
            sessionTime: [],
            filteredSteps: [],
            selectedSkillsAcquisitionProgramIds: [],
            openBatchTargetActiveStatusModal: false,
            openBatchProgramActiveStatusModal: false,
            openBatchUnarchiveSkillAcquisition: false,
            rawDataModal: false,
            targetStatus: '',
            page_number: 1,
            isCurriculumLibraryClicked : false,
            isMoveDomainClicked : false,
        }

        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.setSortColumn = this.setSortColumn.bind(this);
        this.onActiveProgramToggle = this.onActiveProgramToggle.bind(this);
        this.onActiveTargetToggle = this.onActiveTargetToggle.bind(this);
        this.handleNewRequest = this.handleNewRequest.bind(this);
        this.loadProgramsData = this.loadProgramsData.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.ResetAllCheckBoxes = this.ResetAllCheckBoxes.bind(this);
    }


    componentWillMount() {
        let masterData = { 'masterdata': 'MASTERDOMAINSWITHLIBRARY,MASTERPROGRAMS,MASTERDESIREDDAILYTRIALS,MASTERAUTOOPENORDER,MASTERTARGETTYPE,MASTERRESPONSEPERCENTAGE,MASTERCONSECUTIVEDAYS,MASTERFIRSTTRIALMUSTBEINDEPENDENT,MASTERYTYPE,TARGETSTATUS,TARGETSTATUSWITHOUTREADY,DCMASTERMAINTENANCELEVELS,MASTERSTAFFACTIVEANDINACTIVE' };
        this.props.getMasterData(masterData);
        this.loadData()

        let searchObj = {
            contain_filters: { patientId: this.state.patientId || null },
            pageNumber: 1,
        };
        this.props.getPromptCodeList(searchObj);
        this.props.getPatientSkillAcqTaskAnalysislist(this.state.patientId);
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.saved_skillAcquisitionDomain && nextProps.saved_skillAcquisitionDomain !== this.props.saved_skillAcquisitionDomain) {
            this.loadData();
        }
        let masterDomains = [];
        let masterPrograms = [];

        if (nextProps.masterDomains && nextProps.masterDomains !== undefined && nextProps.masterDomains.length > 0) {
            masterDomains = nextProps.masterDomains;
            masterPrograms = nextProps.masterPrograms;
        }
        if (nextProps.skillAcquisitionDomainList !== null && nextProps.skillAcquisitionDomainList !== undefined) {
            this.setState({
                domainData: nextProps.skillAcquisitionDomainList.data
            });
        } else {
            this.setState({
                domainData: []
            })
        }

        this.setState({
            masterDomains: masterDomains,
            masterPrograms: masterPrograms,
            desiredDailyTrials: nextProps.desiredDailyTrials !== null && nextProps.desiredDailyTrials,
            masteryType: nextProps.masteryType !== null && nextProps.masteryType,
            autoOpenOrder: nextProps.autoOpenOrder !== null && nextProps.autoOpenOrder,
            targetType: nextProps.targetType !== null && nextProps.targetType,
            responsePercentage: nextProps.responsePercentage !== null && nextProps.responsePercentage,
            consecutiveDays: nextProps.consecutiveDays !== null && nextProps.consecutiveDays,
            firstTrialMustBeIndependent: nextProps.firstTrialMustBeIndependent !== null && nextProps.firstTrialMustBeIndependent,
            dcMasterMaintenanceLevels: nextProps.dcMasterMaintenanceLevels !== null && nextProps.dcMasterMaintenanceLevels
        });

        let programListArray = (nextProps.skillAcquisitionProgramList && nextProps.skillAcquisitionProgramList.data) || [];
        let activeProgramToggleValues = new Array(programListArray.length).fill({});
        let index = 0;
        programListArray.map((obj) => {
            if (activeProgramToggleValues.indexOf(obj) === -1) {
                activeProgramToggleValues.splice(index, 1, obj);
                index = index + 1;
            }
            return activeProgramToggleValues;
        });

        this.setState({
            activeProgramToggleValues,
        });


        let targetListArray = (nextProps.skillAcquisitionTargetList && nextProps.skillAcquisitionTargetList.data) || [];
        let activeTargetToggleValues = new Array(targetListArray.length).fill({});
        let index1 = 0;
        targetListArray.map((obj) => {
            if (activeTargetToggleValues.indexOf(obj) === -1) {
                activeTargetToggleValues.splice(index1, 1, obj);
                index1 = index1 + 1;
            }
            return activeTargetToggleValues;
        });

        this.setState({
            activeTargetToggleValues,
        });

        if (nextProps.skillAcquisitionTargetList && nextProps.skillAcquisitionTargetList.data && this.state.skillsAcquisitionProgramId !== null) { //&& nextProps.skillAcquisitionTargetList.data !== this.props.skillAcquisitionTargetList.data             
            (nextProps.skillAcquisitionTargetList.data || []).forEach((obj, index) => {
                this.props.dispatch(change('SkillAquisitionForm', `Targets[${index}].status`, obj.status || null));
            });
        }

        if (nextProps.archiveBatchDCStatus && nextProps.archiveBatchDCStatus !== this.props.archiveBatchDCStatus) {
            this.setState({ selectedSkillsAcquisitionProgramIds : [], selectedSkillsAcquisitionTargetIds : [] },()=>{
                this.ResetAllCheckBoxes();
              this.loadData();
            });      
          } 
    }

    setSortColumn = (col_name, col_order) => {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }

    handleNewRequest(input, selectedValue, skillsAcqTargetId) {
        input.onChange(selectedValue.value);
        this.props.updateTargetStatus(skillsAcqTargetId, selectedValue.value || null, this.state.patientId, this.state.skillsAcquisitionProgramId, this.state.page_number);
    }

    onActiveProgramToggle(e, index, Obj) {
        alertConfirmation('Are you sure you want to change program\'s active status?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleActiveProgramAlertClick,
                // value: e.target.value,
                id: index,
                userID: Obj.skillsAcquisitionProgramId,
            },
        });
    };

    handleActiveProgramAlertClick = (event, index, userID) => {
        let activeProgramToggleValues = this.state.activeProgramToggleValues;
        activeProgramToggleValues[index].isActive = !activeProgramToggleValues[index].isActive;
        this.setState({ activeProgramToggleValues });
        this.props.updateProgramActiveStatus(userID, this.state.activeProgramToggleValues[index].isActive);
        Alert.closeAll();
    };

    handleUpdateInstructionClick = (e, obj) => {
        Alert.closeAll();
        this.setState({ openProgramInstruction: true, skillsAcquisitionProgramId: obj.skillsAcquisitionProgramId })
    }

    handleCloneProgramClick = (e, obj) => {
        Alert.closeAll();
        let postData = {
            "SkillAcquisitionDomainId": obj.skillsAcquisitionDomainId,
            "SkillAcquisitionProgramId": obj.skillsAcquisitionProgramId,
            "PatientId": parseInt(this.state.patientId),
        }
        this.props.copyPatientSkillAcquisitionProgram(postData, this.state.patientId, obj.skillsAcquisitionDomainId);
    }

    handleCloneTargetClick = (e, obj) => {
        Alert.closeAll();
        let postData = {
            "SkillAcquisitionProgramId": obj.skillsAcquisitionProgramId,
            "SkillAcquisitionTargetId": obj.id,
            "PatientId": parseInt(this.state.patientId),
        }
        this.props.copyPatientSkillAcquisitionTarget(postData, this.state.patientId, obj.skillsAcquisitionProgramId);
    }

    onProgramClickHandler = (e, obj, page_number) => {
        this.setState({
            isProgramClicked: true,
            isAddRawDataClicked: false,
            programId: obj.programId,
            skillsAcquisitionProgramId: obj.skillsAcquisitionProgramId
        })
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number !== undefined ? page_number : 1,
        };
        this.props.getSkillAcquisitionTargetList(searchObj, this.state.patientId, obj.skillsAcquisitionProgramId)
    }

    checkAllTargets = (e) => {
        let isAllTargetChecked = e.target.checked;
        let targetListData = (this.props.skillAcquisitionTargetList && this.props.skillAcquisitionTargetList.data) || [];
        let selectedSkillsAcquisitionTargetIds = [];
        targetListData != null && targetListData.forEach((obj, Index) => {
            let targetIdCheck = `Targets[${Index}].Chk`;
            if (obj && isAllTargetChecked) {
                selectedSkillsAcquisitionTargetIds.push(obj.id);
                this.props.dispatch(change('SkillAquisitionForm', targetIdCheck, true));
            } else {
                this.props.dispatch(change('SkillAquisitionForm', targetIdCheck, false));
            }
        });
        this.setState({ selectedSkillsAcquisitionTargetIds: selectedSkillsAcquisitionTargetIds });
    }

    checkTargets = (e, index, data) => {
        let selectedSkillsAcquisitionTargetIds = this.state.selectedSkillsAcquisitionTargetIds;
        let isTargetChecked = e.target.checked;
        if (isTargetChecked) {
            selectedSkillsAcquisitionTargetIds.push(data.id);
        }
        else {
            index = selectedSkillsAcquisitionTargetIds.findIndex((value) => value === data.id);
            if (index >= 0) {
                selectedSkillsAcquisitionTargetIds.splice(index, 1);
            }
        }

        this.setState({ selectedSkillsAcquisitionTargetIds: selectedSkillsAcquisitionTargetIds });
    }

    checkAllPrograms = (e) => {       
        let isAllProgramChecked = e.target.checked;
        let programListData = (this.props.skillAcquisitionProgramList && this.props.skillAcquisitionProgramList.data) || [];
        let selectedSkillsAcquisitionProgramIds = [];
        programListData != null && programListData.forEach((obj, Index) => {
            let programIdCheck = `Programs[${Index}].Chk`;
            if (obj && isAllProgramChecked) {
                selectedSkillsAcquisitionProgramIds.push(obj.id);
                this.props.dispatch(change('SkillAquisitionForm', programIdCheck, true));
            } else {
                this.props.dispatch(change('SkillAquisitionForm', programIdCheck, false));
            }
        });
        this.setState({ selectedSkillsAcquisitionProgramIds: selectedSkillsAcquisitionProgramIds });
    }

    checkPrograms = (e, index, data) => {
        let selectedSkillsAcquisitionProgramIds = this.state.selectedSkillsAcquisitionProgramIds;       
        let isProgramChecked = e.target.checked;
        if (isProgramChecked) {
            selectedSkillsAcquisitionProgramIds.push(data.id);
        }
        else {
            index = selectedSkillsAcquisitionProgramIds.findIndex((value) => value === data.id);
            if (index >= 0) {
                selectedSkillsAcquisitionProgramIds.splice(index, 1);
            }
        }

        this.setState({ selectedSkillsAcquisitionProgramIds: selectedSkillsAcquisitionProgramIds });
    }

    renderData = (programList) => {
        programList = programList || [];
        if (!programList.length) {
            return (
                <tr>
                    <td colSpan="7">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return programList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td width="5%">
                        <div className="table_custom-check">                            
                            <Field
                                name={`Programs[${index}].Chk`}
                                component={renderCheckBox}
                                onChange={(e) => this.checkPrograms(e, index, Obj)}
                                style={stylescss.checkbox}
                            />                             
                        </div>
                    </td>
                    {this.props.viewTargetPermission ?
                        <td width="30%"><a href="#" onClick={(e) => this.onProgramClickHandler(e, Obj, 1)}><i className="fa fa-folder" style={{ color: '#F0E68C', cursor: 'pointer' }}></i>&nbsp;{Obj.programName}</a></td>
                        :
                        <td width="30%"><i className="fa fa-folder" style={{ color: '#F0E68C', cursor: 'pointer' }}></i>&nbsp;{Obj.programName}</td>
                    }
                    <td width="15%">{Obj.totalTargets}</td>
                    <td width="15%">{Obj.numberOfOpenTargets}</td>
                    <td width="15%">{Obj.numberOfMasteredTargets}</td>
                    {/* <td width="10%" className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td> */}
                    {/* <td width="5%">Graph</td> */}
                    <td>
                        <Field className="no_margin"
                            name="program_active_status"
                            toggled={this.state.activeProgramToggleValues[index] && this.state.activeProgramToggleValues[index].isActive ? this.state.activeProgramToggleValues[index].isActive : false}
                            component={renderToggleButton}
                            onChange={(e) => this.onActiveProgramToggle(e, index, Obj)}
                        />
                    </td>
                    <td width="10%">
                        {this.props.viewGraphPermissionProgram ?
                            <button type="button" onClick={(e) => this.onProgramGraphClickHandler(e, Obj)} title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                            : null}
                        {this.props.updatePermissionProgram ?
                            <button onClick={(e) => this.handleUpdateInstructionClick(e, Obj)} type="button" title="Update Program Instruction" className="tbactionbtn yellowfont"><i className="fa fa-pencil-square" aria-hidden="true"></i></button>
                            : null}
                        {this.props.copyPermissionProgram ?
                            <button onClick={(e) => this.handleCloneProgramClick(e, Obj)} type="button" title="Clone" className="tbactionbtn bluefont"><i className="fa fa-clone" aria-hidden="true"></i></button>
                            : null}
                        {Obj.isCustomProgram && this.props.updatePermissionProgram ?
                            <button onClick={(e) => this.handleEditClick(e, Obj, 'program')} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                            : null}
                        {/* {this.props.deletePermissionProgram ?
                            <button onClick={(e) => this.handleDeleteClick(e, Obj, 'program')} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                            : null} */}
                    </td>
                </tr>
            )
        })
    }

    handleEditClick = (e, obj, type) => {
        Alert.closeAll();
        if (type === 'program') {
            this.setState({ openNewProgram: true, programId: obj.programId })
        } else if (type === "target") {
            this.setState({
                openNewTarget: true,
                skillAquisitionTargetId: obj.id,
                targetId: obj.targetId,
            });
        }
    }

    handleDeleteClick = (e, obj, type) => {
        if (type === "program") {
            alertConfirmation('Are you sure you want to delete program details?', {
                customFields: {
                    displayComponent: true,
                    handleButtonClick: this.handleAlertClick,
                    id: obj.id,
                },
            });
        } else {
            alertConfirmation('Are you sure you want to delete target details?', {
                customFields: {
                    displayComponent: true,
                    handleButtonClick: this.handleAlertClickTarget,
                    id: obj.id,
                },
            });
        }
    }

    handleAlertClickTarget = (event, targetId) => {
        this.props.deleteSkillAcquisitionTarget(targetId, this.state.patientId, this.state.skillsAcquisitionProgramId);
        Alert.closeAll();
    }

    handleAlertClick = (event, programId) => {
        this.props.deleteSkillAcquisitionProgram(programId, this.state.patientId, this.state.domainId);
        Alert.closeAll();
    }

    onActiveTargetToggle(e, index, Obj) {
        alertConfirmation('Are you sure you want to change target\'s active status?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleActiveTargetAlertClick,
                // value: e.target.value,
                id: index,
                userID: Obj.id,
            },
        });
    };

    handleActiveTargetAlertClick = (event, index, userID) => {
        let activeTargetToggleValues = this.state.activeTargetToggleValues;
        activeTargetToggleValues[index].isActive = !activeTargetToggleValues[index].isActive;
        this.setState({ activeTargetToggleValues });
        this.props.updateTargetActiveStatus(userID, this.state.activeTargetToggleValues[index].isActive, this.state.patientId, this.state.skillsAcquisitionProgramId);
        Alert.closeAll();
    };


    handleViewRawDataClick = (e, obj, type) => {
        if (obj.targetType.toUpperCase() === "TASK ANALYSIS") {
            this.setState({
                rawDataTAModal: true,
                ClickedTargetType: obj.targetType,
                targetId: obj.id,
            })
        } else if (obj.targetType.toUpperCase() === "DTT") {
            this.setState({
                rawDataDttModal: true,
                ClickedTargetType: obj.targetType,
                targetId: obj.id,
            })
        } else if (obj.targetType.toUpperCase() === "DURATION" || obj.targetType.toUpperCase() === "FREQUENCY") {
            this.setState({
                rawDataModal: true,
                ClickedTargetType: obj.targetType,
                targetId: obj.id,
            })
        }
    }

    handleAddRawDataClick = (e, obj, type) => {     
       
            let filteredSteps = [];
            if(obj.targetType.toUpperCase() === "TASK ANALYSIS")
            {
                if (this.props.patientSkillAcqTaskAnalysisList !== null && this.props.patientSkillAcqTaskAnalysisList.data.PatientSkillsAcqTaskAnalysis.length > 0) {
                    let data = this.props.patientSkillAcqTaskAnalysisList.data.PatientSkillsAcqTaskAnalysis
                    
                    filteredSteps = data.filter((Obj, index) => {                      
                        return Obj.skillsAcquisitionTargetId === obj.id;
                    })
                }
            }
            this.setState({
                isAddRawDataClicked: true,
                ClickedTargetType: obj.targetType.toUpperCase(),
                targetId: obj.id,
                sessionDate: [],
                sessionTime: [],
                filteredSteps: filteredSteps,
                targetStatus: obj.targetStatus.toUpperCase(),
            },() => {
                //console.log('this.state.filteredSteps.........',this.state.filteredSteps)
                this.props.dispatch(change('SkillAquisitionForm', `patientSkAcqBehvaiorRawData`, [{}])); 
                this.props.dispatch(change('SkillAquisitionForm', `patientSkillsAcquisitionCollectedRawData`, [{}]));            
            })         
    }

    
    onProgramGraphClickHandler = (e, Obj) => {
        this.setState({
            ProgramGraphModalOpen: true,
            modalTitle: Obj.programName,
            skillsAcquisitionProgramId: Obj.id
        });
    }

    onTargetGraphClickHandler = (e, Obj) => {
        if (Obj.targetType.toUpperCase() === "DTT") {
            this.setState({
                TAGraphModalOpen: false,
                DTTGraphModalOpen: true,
                FrequencyGraphModalOpen: false,
                DurationGraphModalOpen: false,
                modalTitle: Obj.targetName,
                targetType: Obj.targetType,
                skillAquisitionTargetId: Obj.id
            });
        } else if (Obj.targetType.toUpperCase() === "TASK ANALYSIS") {
            this.setState({
                TAGraphModalOpen: true,
                DTTGraphModalOpen: false,
                FrequencyGraphModalOpen: false,
                DurationGraphModalOpen: false,
                modalTitle: Obj.targetName,
                targetType: 'TA',
                skillAquisitionTargetId: Obj.id
            });
        } else if (Obj.targetType.toUpperCase() === "FREQUENCY") {
            this.setState({
                TAGraphModalOpen: false,
                DTTGraphModalOpen: false,
                FrequencyGraphModalOpen: true,
                DurationGraphModalOpen: false,
                modalTitle: Obj.targetName,
                targetType: 'FREQUENCY',
                skillAquisitionTargetId: Obj.id
            });
        } else if (Obj.targetType.toUpperCase() === "DURATION") {
            this.setState({
                TAGraphModalOpen: false,
                DTTGraphModalOpen: false,
                FrequencyGraphModalOpen: false,
                DurationGraphModalOpen: true,
                modalTitle: Obj.targetName,
                targetType: 'DURATION',
                skillAquisitionTargetId: Obj.id
            });
        }
        
    }

    renderDataTarget = (targetList) => {
        targetList = targetList || [];
        if (!targetList.length) {
            return (
                <tr>
                    <td colSpan="8">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }

        if (targetList.length > 0) {
            return targetList.map((Obj, index) => {
                return (
                    <tr key={index}>
                        <td width="5%">
                            <div className="table_custom-check">                            
                                <Field
                                    name={`Targets[${index}].Chk`}
                                    component={renderCheckBox}
                                    onChange={(e) => this.checkTargets(e, index, Obj)}
                                    style={stylescss.checkbox}
                                />                             
                            </div>
                        </td>
                        <td width="20%">{Obj.targetName}</td>
                        {/* <td width="15%">{Obj.status}</td> */}
                        <td width="14%">
                            {Obj.dateOpened ?
                                <Field
                                    name={`Targets[${index}].status`}
                                    hintText="Status"
                                    handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue, Obj.id)}
                                    options={this.props.masterTargetStatusWithoutReady}
                                    component={renderAutoCompleteSingleSelect}
                                />
                                :
                                <Field
                                    name={`Targets[${index}].status`}
                                    hintText="Status"
                                    handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue, Obj.id)}
                                    options={this.props.masterTargetStatus}
                                    disabled={true}
                                    component={renderAutoCompleteSingleSelect}
                                />
                            }
                        </td>
                        <td width="12%">{Obj.dateOpened ? moment(Obj.dateOpened).format('MM-DD-YYYY') : '-'}</td>
                        <td width="14%">{Obj.dateMastered ? moment(Obj.dateMastered).format('MM-DD-YYYY') : '-'}</td>
                        <td width="14%">{Obj.targetType}</td>
                        {/* <td width="10%" className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td> */}
                        {/* <td width="5%">Graph</td> */}
                        <td width="10%">
                            <Field className="no_margin"
                                name="target_active_status"
                                toggled={this.state.activeTargetToggleValues[index] && this.state.activeTargetToggleValues[index].isActive ? this.state.activeTargetToggleValues[index].isActive : false}
                                component={renderToggleButton}
                                onChange={(e) => this.onActiveTargetToggle(e, index, Obj)}
                            />
                        </td>
                        <td width="15%">
                            {/* {this.props.viewRawDataPermissionTarget && Obj.targetType === 'DTT' ? 
                                <button onClick={(e) => this.handleAddRawDataClick(e, Obj, 'target')} type="button" title="Add Raw Data" className="tbactionbtn redfont"><i className="fa fa-plus-square" aria-hidden="true"></i></button>
                                 : null} */}
                            
                            <button onClick={(e) => this.handleAddRawDataClick(e, Obj, 'target')} type="button" title="Add Raw Data" className="tbactionbtn redfont"><i className="fa fa-plus-square" aria-hidden="true"></i></button>
                                 
                            {this.props.viewGraphPermissionTarget ?
                                <button onClick={(e) => this.onTargetGraphClickHandler(e, Obj)} type="button" title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                                : null}
                            {this.props.viewRawDataPermissionTarget ?
                                <button onClick={(e) => this.handleViewRawDataClick(e, Obj, 'target')} type="button" title="View Raw Data" className="tbactionbtn bluefont"><i className="fa fa-list" aria-hidden="true"></i></button>
                                : null}
                            {this.props.copyPermissionTarget && Obj.targetType !== 'Duration' && Obj.targetType !== 'Frequency'  ?
                                <button onClick={(e) => this.handleCloneTargetClick(e, Obj)} type="button" title="Clone" className="tbactionbtn bluefont"><i className="fa fa-clone" aria-hidden="true"></i></button>
                                : null}
                            {Obj.isCustomTarget && this.props.updatePermissionTarget ?
                                <button onClick={(e) => this.handleEditClick(e, Obj, 'target')} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                : null
                            }
                            {/* {this.props.deletePermissionTarget ?
                                <button onClick={(e) => this.handleDeleteClick(e, Obj, 'target')} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                : null} */}
                        </td>
                    </tr>
                )
            });
        }

    }

    handleBack = (page_number) => {
        let searchObj1 = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        this.setState({
            isProgramClicked: false
        }, () => {
            this.props.getSkillAcquisitionProgramList(searchObj1, this.state.patientId, this.state.domainId);
        });
    }

    handleBackToTarget = () => {
        this.setState({                       
            isAddRawDataClicked: false
        });
    }

    editDomainHandler = () => {
        this.setState({
            isEditDomainClicked: true
        })
    }

    deleteDomainHandler = () => {
        alertConfirmation('Are you sure you want to delete this domain?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClickDomain,
                id: '',
            },
        });
        // this.setState({
        //     isOnDomainClick : false,
        //     innerActiveTab: ''
        // });
    }

    handleAlertClickDomain = (event) => {
        this.props.deleteSkillAcquisitionDomain(this.state.domainIdForDelete, this.state.patientId);
        this.setState({
            isOnDomainClick: false,
            innerActiveTab: '0'
        });
        Alert.closeAll();
    }

    handleOpen = (type) => {
        Alert.closeAll();
        if (type === "addDomain") {
            this.setState({ open: true, skillAquisitionDomainId: null, isOnDomainClick: false });
        } else if (type === 'addProgramFromLibrary') {
            this.setState({ openProgramFromLibrary: true, openNewProgram: false, openProgramInstruction: false })
        } else if (type === 'addNewProgram') {
            this.setState({ openNewProgram: true, openProgramFromLibrary: false, openProgramInstruction: false, programId: null })
        } else if (type === 'addNewTarget') {
            this.setState({ openNewTarget: true, openProgramFromLibrary: false, openNewProgram: false, openProgramInstruction: false });
        } else if (type === "BatchUnrchiveSkillAcquisition") {
            this.setState({ openBatchUnarchiveSkillAcquisition: true, skillAquisitionDomainId: null, isOnDomainClick: false });
        }
        
    };


    handleClose = (type) => {
        if (type === 'closeDomainModal') {
            this.setState({ open: false });
        } else if (type === 'closeNewProgramModal') {
            this.setState({ openNewProgram: false })
        } else if (type === "closeAddNewProgramFromLibraryModal") {
            this.setState({ openProgramFromLibrary: false });
        } else if (type === "closeAddNewTarget") {
            this.setState({ openNewTarget: false, skillAquisitionTargetId: null, targetId: null });
        } else if (type === "closeProgramInstructionModal") {
            this.setState({ openProgramInstruction: false, skillsAcquisitionProgramId: null });
        } else if (type === "closeEditDomainModal") {
            this.setState({ isEditDomainClicked: false });
        } else if (type === "closeRawDTTDataModal") {
            this.setState({ rawDataDttModal: false })
        } else if (type === "closeRawDataTAModal") {
            this.setState({ rawDataTAModal: false })
        } else if (type === 'closeBatchUnarchiveSkillAcquisitionModal') {
            this.setState({ openBatchUnarchiveSkillAcquisition: false });
        } else if (type === 'closeRawSkillAquisitionBehaviorDataModal') {
            this.setState({ rawDataModal: false })
        } else if ( type === 'closeCopyCurriculumLibrary'){
            this.setState({ isCurriculumLibraryClicked: false })
        } else if ( type === 'closeMoveDomain'){
            this.setState({ isMoveDomainClicked: false })
        }
        
        
        this.setState({ DTTGraphModalOpen: false, TAGraphModalOpen: false, FrequencyGraphModalOpen: false, DurationGraphModalOpen: false, ProgramGraphModalOpen: false });
    };

    handleBatchTargetStatusClose = () =>{
        (this.state.selectedSkillsAcquisitionTargetIds || []).forEach((obj, index) => {
            this.props.dispatch(change('SkillAquisitionForm', `Targets[${index}].Chk`, null));            
          });

          (this.state.selectedSkillsAcquisitionProgramIds || []).forEach((obj, index) => {
            this.props.dispatch(change('SkillAquisitionForm', `Programs[${index}].Chk`, null));                        
          });
        this.setState({ 
            open: false,
            openNewProgram: false,
            openProgramFromLibrary: false,
            openNewTarget: false,
            openProgramInstruction: false,
            openBatchTargetStatusModal: false,
            openBatchTargetActiveStatusModal: false,
            openBatchProgramActiveStatusModal: false,
            selectedSkillsAcquisitionTargetIds:[],
            selectedSkillsAcquisitionProgramIds:[],
            openBatchUnarchiveSkillAcquisition: false,
            rawDataModal: false,
        },
        ()=>{
            this.props.dispatch(change('SkillAquisitionForm', 'chkTargets', null))
            this.props.dispatch(change('SkillAquisitionForm', 'chkPrograms', null))
        });            
    }

    handleUpdateBatchTargetstatus = (e) => {
        this.setState({
            openBatchTargetStatusModal: true
        });
    }

    handleUpdateBatchTargetActivestatus = (e) => {
        this.setState({
            openBatchTargetActiveStatusModal: true
        });
    }

    handleUpdateBatchProgramActivestatus = (e) => {
        this.setState({
            openBatchProgramActiveStatusModal: true
        });
    }

    loadData(page_number, KEY) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: KEY === 'DOMAIN' ? page_number : 1,
        };
        this.props.getSkillAcquisitionDomainList(searchObj, this.state.patientId)

        let searchObj1 = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: KEY === 'PROGRAM' ? page_number : 1,
        };

        if (this.state.domainId !== null) {
            this.props.getSkillAcquisitionProgramList(searchObj1, this.state.patientId, this.state.domainId);
        }

        let searchObj2 = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: KEY === 'TARGET' ? page_number : 1,
        };

        if (this.state.skillsAcquisitionProgramId !== null) {
            this.props.getSkillAcquisitionTargetList(searchObj2, this.state.patientId, this.state.skillsAcquisitionProgramId)
        }
    }

    loadTargetData(page_number)
    {
        this.setState({isOnDomainClick: true, isProgramClicked: true, isAddRawDataClicked: false, page_number: page_number},()=>this.loadData(page_number,'TARGET'));
    }

    loadProgramData(page_number)
    {
        this.setState({isOnDomainClick: true, isProgramClicked: false, isAddRawDataClicked: false},()=>this.loadData(page_number,'PROGRAM'));
    }

    loadProgramsData() {
        this.filter.sort_Column = '';
        this.filter.sort_order = '';
        this.filter.searchText = '';
        this.loadData(1,'PROGRAM');
    }

    setInnerActive(outertab, value, domainId, parentDomainId, domainIdForDelete, type) {
        if (outertab === 'skill acquisition') {
            var page_number = 1;
            let searchObj = {
                sort_fields: this.filter.sort_Column || '',
                sort_order: this.filter.sort_order || '',
                contain_filters: { SearchText: this.filter.searchText || null },
                pageNumber: page_number || 1,
            };
            this.setState({ innerActiveTab: value, domainId: domainId, parentDomainId: parentDomainId, domainIdForDelete: domainIdForDelete });
            this.props.getSkillAcquisitionProgramList(searchObj, this.state.patientId, domainId);
            if (type === "onDomainClick") {
                let filteredDomain = this.state.masterDomains.filter(obj => {
                    return obj.id === domainId
                })
                let filteredPrograms = this.state.masterPrograms.filter(obj => {
                    return obj.domainId === domainId
                })
                this.setState({
                    isOnDomainClick: true,
                    filteredDomain: filteredDomain,
                    filteredPrograms: filteredPrograms,
                    isProgramClicked: false,
                    isAddRawDataClicked: false
                });
            }
        }
    }

    addRow = () => { };
    removeRow = (i) => { };

  renderRawDTTDataListTemplate = ({ fields }) => {
    this.addRow = (e) => {
      fields.push({});
    };

    this.removeRow = (i, e) => {
      fields.remove(i);
    };
    
    return (        
        <div>  
            {fields.map((patientSkillsAcquisitionCollectedRawData, i) =>             
            <div className="row" key = {i}>
                <div className="col-sm-2">                     
                    <Field
                    name={`patientSkillsAcquisitionCollectedRawData[${i}].sessionDate`}                    
                    placeholder="Session Date"
                    locale="en-US"
                    selected={this.state.sessionDate[i] || null}       
                    onDateChange={(input, value) => this.onDateChange(input, value, i)}                       
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>                   
                <div className="col-sm-2">  
                    <Field
                        name={`patientSkillsAcquisitionCollectedRawData[${i}].sessionTime`}
                        placeholder="Time"
                        fullWidth={true}            
                        selected={this.state.sessionTime[i] || null}                       
                        component={renderTimePicker}
                        onDateChange={(input, value) => this.onTimeChange(input, value, i)}                                      
                    />
                </div>      
                <div className="col-sm-2 mt-40">  
                    <Field
                        name={`patientSkillsAcquisitionCollectedRawData[${i}].id`}
                        hintText="Staff Name"
                        handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                        options={this.props.allStaffs}
                        component={renderAutoCompleteSingleSelect}
                    />
                </div> 

                {this.state.ClickedTargetType.toUpperCase() === "TASK ANALYSIS" ?
                <div className="col-sm-2 mt-40">  
                    <Field
                        name={`patientSkillsAcquisitionCollectedRawData[${i}].taskAnalysisId`}
                        hintText="Step Name"
                        handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                        options={this.state.filteredSteps}
                        component={renderAutoCompleteSingleSelect}
                    />
                </div> : null}

                <div className="col-sm-2 mt-40">  
                    <Field
                        name={`patientSkillsAcquisitionCollectedRawData[${i}].status`}
                        hintText="Status"
                        handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                        options={this.props.masterTargetStatusWithoutReady}
                        component={renderAutoCompleteSingleSelect}
                    />
                </div> 
                {this.state.targetStatus && this.state.targetStatus === 'MASTERED' ?
                    this.state.ClickedTargetType.toUpperCase() === "DTT" ?     
                        <div className="col-sm-2 mt-40">  
                            <Field
                                name={`patientSkillsAcquisitionCollectedRawData[${i}].promptCode`}
                                hintText="Prompt Code"
                                handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                                options={this.props.promptCodeListMastereDTTData}
                                component={renderAutoCompleteSingleSelect}
                            />
                        </div>      
                    :
                        <div className="col-sm-2 mt-40">  
                            <Field
                                name={`patientSkillsAcquisitionCollectedRawData[${i}].promptCode`}
                                hintText="Prompt Code"
                                handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                                options={this.props.promptCodeListMastereTAData}
                                component={renderAutoCompleteSingleSelect}
                            />
                        </div>      
                : 

                    this.state.ClickedTargetType.toUpperCase() === "DTT" ?     
                        <div className="col-sm-2 mt-40">  
                            <Field
                                name={`patientSkillsAcquisitionCollectedRawData[${i}].promptCode`}
                                hintText="Prompt Code"
                                handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                                options={this.props.promptCodeListDTTData}
                                component={renderAutoCompleteSingleSelect}
                            />
                        </div>      
                    :
                        <div className="col-sm-2 mt-40">  
                            <Field
                                name={`patientSkillsAcquisitionCollectedRawData[${i}].promptCode`}
                                hintText="Prompt Code"
                                handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                                options={this.props.promptCodeListTAData}
                                component={renderAutoCompleteSingleSelect}
                            />
                        </div>   
                }
                
                    {fields.length === i + 1 ?                    
                        <div className="col-sm-2 mt-40">
                            {fields.length > 1 ?
                                <button className=" additemtable removeitemtable"
                                onClick={this.removeRow.bind(this, i)}
                                title="Remove Data"
                                type="button">
                                <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                </button>
                                : ''}
                            <button className="additemtable" title="Add Data" onClick={(e) => this.addRow()} type="button">
                                <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                            </button>
                        </div>                      
                        :                      
                        <div className="col-sm-2 mt-40">
                            <button className="additemtable"
                                onClick={this.removeRow.bind(this, i)}
                                title="Remove Data"
                                type="button">
                                <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                            </button>
                        </div>
                       
                    }             
           </div>
            )}
        </div>
    );
  };


  onDateChangeSkillAquisitionBehavior = (input, value, i) => {

    input.onChange(moment(value).format());
    let sessionDate = this.state.sessionDate;

    _.update(sessionDate, `[${i}]`, function (n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    this.setState({ sessionDate: sessionDate }, ()=>{                  
      document.getElementsByName(`patientSkAcqBehvaiorRawData[${i}].sessionTime`)[0].focus();           
   });
  }

  onTimeChangeSkillAquisitionBehavior = (input, value, i) => {

    input.onChange(moment(value).format());
    let sessionTime = this.state.sessionTime;

    _.update(sessionTime, `[${i}]`, function (n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    this.setState({ sessionTime: sessionTime }, ()=>{                  
      document.getElementsByName(`patientSkAcqBehvaiorRawData[${i}].sessionDate`)[0].focus();           
   });
  }

  addSkillAquisitionBehaviorRow = () => { };
  removeSkillAquisitionBehaviorRow = (i) => { };

  renderRawDataListTemplate = ({ fields }) => {
    this.addSkillAquisitionBehaviorRow = (e) => {
      fields.push({});
    };

    this.removeSkillAquisitionBehaviorRow = (i, e) => {
      fields.remove(i);
    };
    //console.log('Hello')
//console.log('this.state.ClickedTargetType.toUpperCase().............',this.state.ClickedTargetType.toUpperCase())
    return (
      <div>
        {fields.map((patientSkAcqBehvaiorRawData, i) =>
          <div className="row" key={i}>
            <div className="col-sm-2 mt-40">
              <Field
                name={`patientSkAcqBehvaiorRawData[${i}].id`}
                hintText="Staff Name"
                handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, i)}
                options={this.props.allStaffs}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-2">
              <Field
                name={`patientSkAcqBehvaiorRawData[${i}].sessionDate`}
                placeholder="Session Date"
                locale="en-US"
                selected={this.state.sessionDate[i] || null}
                onDateChange={(input, value) => this.onDateChangeSkillAquisitionBehavior(input, value, i)}
                openToYearSelection={true}
                component={renderDateField} />
            </div>
            <div className="col-sm-2">
              <Field
                name={`patientSkAcqBehvaiorRawData[${i}].sessionTime`}
                placeholder="Time"
                fullWidth={true}
                selected={this.state.sessionTime[i] || null}
                component={renderTimePicker}
                onDateChange={(input, value) => this.onTimeChangeSkillAquisitionBehavior(input, value, i)}
              />
            </div>
            {this.state.ClickedTargetType.toUpperCase() === "DURATION" ?
              <div className="col-sm-2">
                <Field
                  name={`patientSkAcqBehvaiorRawData[${i}].duration`}
                  type="text"
                  maxLength="4"
                  label="Duration In Min."
                  component={renderTextField}
                  normalize={isFloat}
                />
                <small>(Ex: 15 sec = 0.25 min)</small>
              </div> : null}
            {this.state.ClickedTargetType.toUpperCase() === "FREQUENCY"?
              <div className="col-sm-1">
                <Field
                  name={`patientSkAcqBehvaiorRawData[${i}].value`}
                  type="text"
                  maxLength="2"
                  label="Value"
                  component={renderTextField}
                  normalize={isInteger}
                />
              </div> : null}

              {this.state.ClickedTargetType.toUpperCase() === "RATE" ?
              <div className="col-sm-2">
                <Field
                  name={`patientSkAcqBehvaiorRawData[${i}].duration`}
                  type="text"
                  maxLength="4"
                  label="Duration In Min."
                  component={renderTextField}
                  normalize={isFloat}
                />
                <small>(Ex: 15 sec = 0.25 min)</small>
              </div> : null}
                {this.state.ClickedTargetType.toUpperCase() === "RATE" ?
                    <div className="col-sm-1">
                        <Field
                            name={`patientSkAcqBehvaiorRawData[${i}].value`}
                            type="text"
                            maxLength="2"
                            label="Value"
                            component={renderTextField}
                            normalize={isInteger}
                        />
              </div> : null}
            {fields.length === i + 1 ?
              <div className="col-sm-2 mt-40">
                {fields.length > 1 ?
                  <button className=" additemtable removeitemtable"
                    onClick={this.removeSkillAquisitionBehaviorRow.bind(this, i)}
                    title="Remove Data"
                    type="button">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                  : ''}
                <button className="additemtable" title="Add Data" onClick={(e) => this.addSkillAquisitionBehaviorRow()} type="button">
                  <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                </button>
              </div>
              :
              <div className="col-sm-2 mt-40">
                <button className="additemtable"
                  onClick={this.removeSkillAquisitionBehaviorRow.bind(this, i)}
                  title="Remove Data"
                  type="button">
                  <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                </button>
              </div>

            }
          </div>
        )}
      </div>
    );
  };

  onSubmitHandlerSkillAquisitionBehavior(formData) {
    // console.log(formData);
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    this.props.clearFieldErrorArray();

    // ---------------Start Save to patientSkAcqBehvaiorRawData ------------
    // console.log(formData.patientSkAcqBehvaiorRawData);
    let listRawDATA = [];
    if (formData.patientSkAcqBehvaiorRawData && formData.patientSkAcqBehvaiorRawData.length) { //  Save Tags
      formData.patientSkAcqBehvaiorRawData.filter((data, i) => {
        if (data.id) {
          let timeVal  = this.convertToHHmmss(data.sessionTime)
          let sessionDate = moment(data.sessionDate).format('YYYY-MM-DD') + 'T' + timeVal;

          if (this.state.ClickedTargetType.toUpperCase() === 'FREQUENCY') {
            let currentData = {
              'sessionDate': sessionDate,
              'staffId': data.id,
              'value': data.value,
              'duration': null,
              'patientId': this.state.patientId,
              'skillsAcquisitionTargetId': this.state.targetId,
              'skillsAcquisitionProgramId': this.state.skillsAcquisitionProgramId,
              'actionString': this.state.ClickedTargetType.toUpperCase(),
              'recordingTypeName': this.state.ClickedTargetType.toUpperCase(),
            };
            listRawDATA.push(currentData);
          }
          else if (this.state.ClickedTargetType.toUpperCase() === 'DURATION') {
            let currentData = {
              'sessionDate': sessionDate,
              'staffId': data.id,
              'value': null,
              'duration': data.duration,
              'patientId': this.state.patientId,
              'skillsAcquisitionTargetId': this.state.targetId,
              'skillsAcquisitionProgramId': this.state.skillsAcquisitionProgramId,
              'actionString': this.state.ClickedTargetType.toUpperCase(),
              'recordingTypeName': this.state.ClickedTargetType.toUpperCase(),
            };
            listRawDATA.push(currentData);
          }          
        }
        return listRawDATA;
      });
    }
    formData.patientSkAcqBehvaiorRawData = listRawDATA;
    // ---------------End Save to patientSkAcqBehvaiorRawData ------------
    // console.log('formData.............',formData)

    this.props.SaveRawSkillAquisitionBehaviorData(formData, this.state.patientId);

    this.setState({ open: false, rawDataModal: false, isAddRawDataClicked: false, openBatchUnarchiveSkillAcquisition: false });
    //this.props.closeDialog();
  }

   convertToHHmmss=(input)=>{
    let date;
  
    // Check if input matches the format DD:MM:YYTHH:mm:ss
    if (/^\d{2}:\d{2}:\d{2}T\d{2}:\d{2}:\d{2}$/.test(input)) {
        const [datePart, timePart] = input.split('T');
        const [day, month, year] = datePart.split(':');
        const [hours, minutes, seconds] = timePart.split(':');
        date = new Date(`20${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
    }
    // Check if input matches the 12-hour format HH:mm am/pm
    else if (/^\d{1,2}:\d{2}\s?(am|pm)$/i.test(input)) {
        date = new Date(`1970-01-01 ${input}`);
    }
    // Check if input matches ISO 8601 format (e.g., YYYY-MM-DDTHH:mm:ss±HH:mm)
    else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})?$/.test(input)) {
        date = new Date(input);
    }
    // Handle invalid input
    else {
        throw new Error('Invalid input format');
    }
  
    // Format to HH:mm:ss
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }
  
  onSubmitHandler(formData) {
    // console.log(formData);
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    
    this.props.clearFieldErrorArray();

    // ---------------Start Save to patientSkillsAcquisitionCollectedRawData ------------
    // console.log(formData.patientSkillsAcquisitionCollectedRawData);
    let listRawDATA = [];
    if (formData.patientSkillsAcquisitionCollectedRawData && formData.patientSkillsAcquisitionCollectedRawData.length) { //  Save Tags
      formData.patientSkillsAcquisitionCollectedRawData.filter((data, i) => {
         if (data.id && data.status && data.promptCode) {
          let timeVal  = this.convertToHHmmss(data.sessionTime)              
          let sessionDate =  moment(data.sessionDate).format('YYYY-MM-DD') + 'T' + timeVal;            
          
           if(this.state.ClickedTargetType.toUpperCase() === 'DTT')
            {
                let currentData = {
                    'staffId': data.id,
                    'patientPromptCodeId': data.promptCode,
                    'sessionDate': sessionDate,
                    'statusId': data.status,
                    'patientId': this.state.patientId,
                    'skillsAcquisitionTargetId': this.state.targetId,
                    'skillsAcquisitionProgramId': this.state.skillsAcquisitionProgramId,
                    'patientCollectedDataTaskAnalysisModel': null,                               
                    'actionString': this.state.ClickedTargetType.toUpperCase()
                   };
                   listRawDATA.push(currentData);
            }
            else if(this.state.ClickedTargetType.toUpperCase() === "TASK ANALYSIS")
            {
                let currentData = {
                    "id": 0,
                    'skillsAcquisitionProgramId': this.state.skillsAcquisitionProgramId,
                    'skillsAcquisitionTargetId': this.state.targetId,
                    'patientId': this.state.patientId,                   
                    'sessionDate': sessionDate,
                    'patientPromptCodeId': null,
                    'score': null,
                    'statusId': data.status,          
                    'staffId': data.id,               
                    'actionString': this.state.ClickedTargetType.toUpperCase(),
                    'patientCollectedDataTaskAnalysisModel': [
                      {
                        'taskAnalysisId': data.taskAnalysisId,
                        'patientPromptCodeId': data.promptCode,                        
                        'statusId': data.status,
                      }
                    ]
                  };
                   listRawDATA.push(currentData);
            }
        }
        return listRawDATA;
      });
    }
    formData.patientSkillsAcquisitionCollectedRawData = listRawDATA;
    // ---------------End Save to patientSkillsAcquisitionCollectedRawData ------------
   
    this.props.saveSkillsAcquisitionRawData(formData);
    this.setState({ open: false, rawDataModal: false, isAddRawDataClicked: false, openBatchUnarchiveSkillAcquisition: false });
    //this.props.closeDialog();
  }

  onDateChange = (input, value, i) => {
      
    input.onChange(moment(value).format());
    let sessionDate = this.state.sessionDate;

    _.update(sessionDate, `[${i}]`, function(n) {
        return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });
              
    this.setState({ sessionDate : sessionDate  }, ()=>{                  
         document.getElementsByName(`patientSkillsAcquisitionCollectedRawData[${i}].sessionTime`)[0].focus();           
      });

}

onTimeChange = (input, value, i) => {

    input.onChange(moment(value).format());       
    let sessionTime = this.state.sessionTime;

    _.update(sessionTime, `[${i}]`, function(n) {
        return  moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    this.setState({ sessionTime: sessionTime }, ()=>{            
        document.getElementsByName(`patientSkillsAcquisitionCollectedRawData[${i}].sessionDate`)[0].focus();           
     });        
}

handleNewRequestStatus = (input, selectedRecord, targetId) => {
    input.onChange(selectedRecord.value);       
};

ResetAllCheckBoxes()
  {
    if(this.state.isProgramClicked === false) {
        this.props.dispatch(change('SkillAquisitionForm', 'chkPrograms', false)); 
        this.props.skillAcquisitionProgramList != null && this.props.skillAcquisitionProgramList && this.props.skillAcquisitionProgramList.data.forEach((obj, Index) => {
            let idCheck = `Programs[${Index}].Chk`;                
            this.props.dispatch(change('SkillAquisitionForm', idCheck, false)); 
        });
    }
    else if (this.state.isAddRawDataClicked === false) {
        this.props.dispatch(change('SkillAquisitionForm', 'chkTargets', false));           
        this.props.skillAcquisitionTargetList != null && this.props.skillAcquisitionTargetList && this.props.skillAcquisitionTargetList.data.forEach((obj, Index) => {
        let idCheck = `Targets[${Index}].Chk`;                
        this.props.dispatch(change('SkillAquisitionForm', idCheck, false));           
        });
    }
  }

  handleAlertArchiveBatchDomainClick = (event) => {
    this.props.UpdateDCArchiveStatus(this.state.domainIdForDelete.toString(), true, 'SkillAcquisitionDomain', this.state.patientId);
    Alert.closeAll();
  }

  handleArchiveBatchDomainClick = (event) => {
    Alert.warning('Are you sure you want to archive selected domain(s)?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertArchiveBatchDomainClick,
        //id: obj.id,
      },
    });
  }

  handleCopyCurriculumLibraryClick = () => {
    this.setState({
        isCurriculumLibraryClicked: true
    })
  }
  handleMoveDomainClick = () => {
    this.setState({
        isMoveDomainClicked: true
    })
  }

  handleAlertArchiveBatchProgramsClick = (event) => {
    this.props.UpdateDCArchiveStatus(this.state.selectedSkillsAcquisitionProgramIds.toString(), true, 'SkillAcquisitionProgram', this.state.patientId);
    Alert.closeAll();
  }

  handleArchiveBatchProgramsClick = (event) => {
    Alert.warning('Are you sure you want to archive selected program(s)?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertArchiveBatchProgramsClick,
        //id: obj.id,
      },
    });
  }

  handleAlertArchiveBatchTargetsClick = (event) => {
    this.props.UpdateDCArchiveStatus(this.state.selectedSkillsAcquisitionTargetIds.toString(), true, 'SkillAcquisitionTarget', this.state.patientId);
    Alert.closeAll();
  }

  handleArchiveBatchTargetsClick = (event) => {
    Alert.warning('Are you sure you want to archive selected target(s)?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertArchiveBatchTargetsClick,
        //id: obj.id,
      },
    });
  }

    renderSkillAquisitionTabs(handleSubmit) {
        let component = null;
        innerTabStyles.tab = [];
        for (let i = 0; i < this.state.domainData.length; i++) {
            innerTabStyles.tab[i] = innerTabStyles.default_tab;
        }
        innerTabStyles.tab[this.state.innerActiveTab] = innerTabStyles.active_tab;
        const { skillAcquisitionProgramList, skillAcquisitionTargetList } = this.props;
        let programList = (skillAcquisitionProgramList && skillAcquisitionProgramList.data) || [];
        let programMeta = (skillAcquisitionProgramList && skillAcquisitionProgramList.meta) || null
        let targetList = (skillAcquisitionTargetList && skillAcquisitionTargetList.data) || [];
        let targetMeta = (skillAcquisitionTargetList && skillAcquisitionTargetList.meta) || [];
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });       
        for (let i = 0; i < this.state.domainData.length; i++) {
            if (this.state.innerActiveTab == i && this.state.isOnDomainClick == true) {
                component =
                    <div>
                        {
                            !this.state.isProgramClicked
                                ?
                                <div className="row">
                                    <div className="col-sm-4 col-md-4 col-lg-4 mt-10">
                                        {this.props.addPermissionProgram ?
                                            <RaisedButton
                                                label="Add Program From Library"
                                                primary={true}
                                                onTouchTap={() => this.handleOpen('addProgramFromLibrary')} />
                                            : null}
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-lg-4 mt-10">
                                        {this.props.addPermissionProgram ?
                                            <RaisedButton
                                                label="Add New Program" primary={true} onTouchTap={() => this.handleOpen('addNewProgram')} />
                                            : null}
                                    </div>

                                    <div className="col-sm-4 col-md-4 col-lg-4 mt-10">
                                        {this.props.updatePermissionDomain ?
                                            <RaisedButton
                                                label="Edit Domain"
                                                primary={true}
                                                onTouchTap={() => this.editDomainHandler()} />
                                            : null}
                                    </div>
                                    {/* <div className="col-sm-4 col-md-4 col-lg-4 mt-10">
                                        {this.props.deletePermissionDomain ?
                                            <RaisedButton
                                                label="Delete Domain"
                                                primary={true}
                                                onTouchTap={() => this.deleteDomainHandler()} />
                                            : null}
                                    </div> */}
                                    <div className="col-sm-4 col-md-4 col-lg-4 mt-10">
                                        {this.props.deletePermissionDomain ?
                                            <RaisedButton
                                                label="Archive Domain"
                                                primary={true}
                                                onTouchTap={() => this.handleArchiveBatchDomainClick()} />
                                            : null}
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-lg-4 mt-10">
                                        <RaisedButton
                                        label="Copy To Curriculum library"
                                        primary={true}
                                        onTouchTap={() => this.handleCopyCurriculumLibraryClick()} />
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-lg-4 mt-10">
                                        <RaisedButton
                                        label="Move To Different Domain/Program"
                                        primary={true}
                                        onTouchTap={() => this.handleMoveDomainClick()} />
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-lg-4 mt-10 reset-btn claims_btn">                         
                                        <RaisedButton className={this.state.selectedSkillsAcquisitionProgramIds.length > 0 ? "grey_btn" : "grey_btn reset-disable"}
                                                disabled={this.state.selectedSkillsAcquisitionProgramIds.length > 0 ? false : true}
                                                primary={true} onTouchTap={(e) => this.handleUpdateBatchProgramActivestatus(e)} >Update Batch Program Active Status </RaisedButton>
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 mt-10 reset-btn claims_btn">
                                        <RaisedButton className={this.state.selectedSkillsAcquisitionProgramIds.length > 0 ? "grey_btn" : "grey_btn reset-disable"}
                                                disabled={this.state.selectedSkillsAcquisitionProgramIds.length > 0 ? false : true}
                                                onTouchTap={(e) => this.handleArchiveBatchProgramsClick(e)} >Archive Program</RaisedButton>
                                    </div>
                                </div>
                                :
                                !this.state.isAddRawDataClicked ? 
                                    <div className="row">
                                        <div className="col-sm-2 mt-10">
                                            <RaisedButton
                                                //style={{ marginTop: '10px', marginBottom: '10px' }} 
                                                label="Back" primary={true} onTouchTap={() => this.handleBack()} />
                                        </div>
                                        <div className="col-sm-2 mt-10">
                                            {this.props.addPermissionTarget ?
                                                <RaisedButton
                                                    //style={{ marginTop: '10px', marginBottom: '10px', marginLeft: '30px' }} 
                                                    label="Add New Target" primary={true} onTouchTap={() => this.handleOpen('addNewTarget')} />
                                                : null}
                                        </div>
                                        <div className="col-4 col-sm-4 col-md-4 mt-10 reset-btn claims_btn">
                                            <RaisedButton className={this.state.selectedSkillsAcquisitionTargetIds.length > 0 ? "grey_btn " : "grey_btn reset-disable"}
                                                    disabled={this.state.selectedSkillsAcquisitionTargetIds.length > 0 ? false : true}
                                                    onTouchTap={(e) => this.handleUpdateBatchTargetstatus(e)} >Update Batch Target Status </RaisedButton>                                            
                                        </div>
                                        <div className="col-4 col-sm-4 col-md-4 mt-10 reset-btn claims_btn">
                                            <RaisedButton className={this.state.selectedSkillsAcquisitionTargetIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}
                                                    disabled={this.state.selectedSkillsAcquisitionTargetIds.length > 0 ? false : true}
                                                    onTouchTap={(e) => this.handleUpdateBatchTargetActivestatus(e)} >Update Batch Target Active Status </RaisedButton>
                                        </div>
                                        <div className="col-4 col-sm-4 col-md-4 mt-10 reset-btn claims_btn">
                                            <RaisedButton className={this.state.selectedSkillsAcquisitionTargetIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}
                                                    disabled={this.state.selectedSkillsAcquisitionTargetIds.length > 0 ? false : true}
                                                    onTouchTap={(e) => this.handleArchiveBatchTargetsClick(e)} >Archive Target</RaisedButton>
                                        </div>
                                    </div>
                                : <div className="row">
                                        <div className="col-sm-3 mt-10">
                                            <RaisedButton
                                                //style={{ marginTop: '10px', marginBottom: '10px' }} 
                                                label="Back" primary={true} onTouchTap={() => this.handleBackToTarget()} />
                                        </div>
                                    </div>
                                                
                        }
                        {
                            this.state.openNewProgram &&
                            <AddNewProgramModal
                                programId={this.state.programId}
                                closeDialog={() => this.handleClose("closeNewProgramModal")}
                                domainId={this.state.domainId}
                                programFromLIbrary={!this.state.openProgramFromLibrary}
                                patientId={this.state.patientId}
                                loadProgramsData={() => this.loadProgramsData()}
                            />
                        }
                        {
                            this.state.openProgramFromLibrary &&
                            <ProgramFromLibraryModal
                                programId={this.state.programId}
                                closeDialog={() => this.handleClose("closeAddNewProgramFromLibraryModal")}
                                domainId={this.state.domainId}
                                parentDomainId={this.state.parentDomainId}
                                programFromLIbrary={this.state.openProgramFromLibrary}
                                patientId={this.state.patientId}
                                masterPrograms={this.state.masterPrograms}
                                loadData={() => this.loadData(1,'PROGRAM')}
                            />
                        }
                        {
                            this.state.openNewTarget &&
                            <TargetModalCustom
                                closeDialog={() => this.handleClose("closeAddNewTarget")}
                                domainId={this.state.domainId}
                                programId={this.state.programId}
                                skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                skillAquisitionTargetId={this.state.skillAquisitionTargetId}
                                targetId={this.state.targetId}
                                masterPrograms={this.state.filteredPrograms}
                                masterDomains={this.state.filteredDomain}
                                patientId={this.state.patientId}
                                desiredDailyTrials={this.state.desiredDailyTrials}
                                masteryType={this.state.masteryType}
                                autoOpenOrder={this.state.autoOpenOrder}
                                targetType={this.state.targetType}
                                responsePercentage={this.state.responsePercentage}
                                consecutiveDays={this.state.consecutiveDays}
                                firstTrialMustBeIndependent={this.state.firstTrialMustBeIndependent}
                                dcMasterMaintenanceLevels={this.state.dcMasterMaintenanceLevels}
                                loadData={() => this.loadData(1,'TARGET')}
                            />
                        }
                        {
                            this.state.openProgramInstruction &&
                            <ProgramInstructionModal
                                skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                closeDialog={() => this.handleClose("closeProgramInstructionModal")}
                            />
                        }
                        {
                            this.state.isEditDomainClicked &&
                            <EditDomainModal
                                patientId={this.state.patientId}
                                domainId={this.state.domainId}
                                closeDialog={() => this.handleClose("closeEditDomainModal")}
                            />
                        }
                        {
                            this.state.rawDataDttModal &&
                            <RawDataDTTModal                                
                                targetId={this.state.targetId}
                                patientId={this.state.patientId}
                                targetType={this.state.ClickedTargetType}
                                skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                closeDialog={() => this.handleClose("closeRawDTTDataModal")}
                            />
                        }
                        {
                            this.state.rawDataTAModal &&
                            <RawDataTAModal
                                targetId={this.state.targetId}
                                patientId={this.state.patientId}
                                targetType={this.state.ClickedTargetType}
                                skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                closeDialog={() => this.handleClose("closeRawDataTAModal")}
                            />
                        }
                        {
                            this.state.rawDataModal &&
                            <RawDataSkillAquisitionBehaviorModal
                                skillsAcquisitionTargetId={this.state.targetId}
                                skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                patientId={this.state.patientId}
                                recordingTypeName={this.state.ClickedTargetType}
                                closeDialog={() => this.handleClose("closeRawSkillAquisitionBehaviorDataModal")}
                            />
                        }
                        <div className="row">
                            <div className="col-sm-12">
                                {
                                    !this.state.isProgramClicked
                                        ?
                                        <div className="table-responsive mt-15">
                                            <table className={tableClass}>
                                                <thead>
                                                    <tr>
                                                        <th width="5%">
                                                            <div className="table_custom-check">
                                                                <Field
                                                                    name='chkPrograms'
                                                                    component={renderCheckBox}
                                                                    onChange={(e) => this.checkAllPrograms(e)}     
                                                                    style={stylescss.checkbox}                                                             
                                                                />
                                                                <span>&nbsp;</span>
                                                            </div>
                                                        </th>
                                                        <th width="30%"><SortingCustom noSort={!programList.length} setSortColumn={this.setSortColumn} columnName='programName' displayName='Program Name' /></th>
                                                        <th width="15%">Total Targets</th>
                                                        <th width="15%"># of Open Targets</th>
                                                        <th width="15%"># of Mastered Targets</th>
                                                        {/* <th width="5%">Graph</th> */}
                                                        <th width="10%">Active</th>
                                                        <th width="10%">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.renderData(programList)}
                                                </tbody>
                                            </table>
                                            {programMeta && programMeta['totalPages'] ?
                                                <PaginatorCustom data={programMeta} handlePageChange={(page_number) => this.loadProgramData(page_number)} />
                                                : null}
                                            {
                                                this.state.ProgramGraphModalOpen &&
                                                <ProgramGraphModal
                                                    patientId={this.state.patientId}
                                                    closeDialog={() => this.handleClose()}
                                                    skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                                    modalTitle={this.state.modalTitle}
                                                />
                                            }
                                        </div>
                                        :
                                        !this.state.isAddRawDataClicked ? 
                                            <div className="table-responsive mt-15">
                                                <table className={tableClass}>
                                                    <thead>
                                                        <tr>
                                                            <th width="5%">
                                                                <div className="table_custom-check">
                                                                    <Field
                                                                        name='chkTargets'
                                                                        component={renderCheckBox}
                                                                        onChange={(e) => this.checkAllTargets(e)}     
                                                                        style={stylescss.checkbox}                                                             
                                                                    />
                                                                    <span>&nbsp;</span>
                                                                </div>
                                                            </th>
                                                            <th width="20%"><SortingCustom noSort={!targetList.length} setSortColumn={this.setSortColumn} columnName='targetName' displayName='Target Name' /></th>
                                                            <th width="14%">Status</th>
                                                            <th width="12%">Date Opened</th>
                                                            <th width="14%">Date Mastered</th>
                                                            <th width="14%">Type</th>
                                                            {/* <th width='5%'>Graph</th>                                                         */}
                                                            <th width='10%'>Active</th>
                                                            <th width="15%">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.renderDataTarget(targetList)}
                                                    </tbody>
                                                </table>
                                                {targetMeta && targetMeta['totalPages'] ?
                                                    <PaginatorCustom data={targetMeta} handlePageChange={(page_number) => this.loadTargetData(page_number)} />
                                                    : null}

                                                {
                                                    this.state.DTTGraphModalOpen &&
                                                    <DTTGraphModal
                                                        patientId={this.state.patientId}
                                                        closeDialog={() => this.handleClose()}
                                                        targetType={this.state.targetType}
                                                        skillAquisitionTargetId={this.state.skillAquisitionTargetId}
                                                        skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                                        modalTitle={this.state.modalTitle}
                                                    />
                                                }
                                                {
                                                    this.state.TAGraphModalOpen &&
                                                    <TAGraphModal
                                                        patientId={this.state.patientId}
                                                        closeDialog={() => this.handleClose()}
                                                        targetType={this.state.targetType}
                                                        skillAquisitionTargetId={this.state.skillAquisitionTargetId}
                                                        skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                                        modalTitle={this.state.modalTitle}
                                                    />
                                                }
                                                {
                                                    this.state.FrequencyGraphModalOpen &&
                                                    <FrequencyGraphModal
                                                        patientId={this.state.patientId}
                                                        closeDialog={() => this.handleClose()}
                                                        targetType={this.state.targetType}
                                                        skillAquisitionTargetId={this.state.skillAquisitionTargetId}
                                                        skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                                        modalTitle={this.state.modalTitle}
                                                    />
                                                }
                                                {
                                                    this.state.DurationGraphModalOpen &&
                                                    <DurationGraphModal
                                                        patientId={this.state.patientId}
                                                        closeDialog={() => this.handleClose()}
                                                        targetType={this.state.targetType}
                                                        skillAquisitionTargetId={this.state.skillAquisitionTargetId}
                                                        skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                                                        modalTitle={this.state.modalTitle}
                                                    />
                                                }
                                            </div>
                                        : 
                                        (this.state.ClickedTargetType.toUpperCase() === "DTT" || this.state.ClickedTargetType.toUpperCase() === "TASK ANALYSIS") ? 
                                        <div>
                                            <div className="clearfix"></div>                                        
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} >    
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                    <div className="panel_title">
                                                        <h3>Add Raw {this.state.ClickedTargetType.toUpperCase()} Data</h3>
                                                        <i className="flaticon flaticon-calendar-1"></i>
                                                    </div>

                                                    <FieldArray name="patientSkillsAcquisitionCollectedRawData" component={this.renderRawDTTDataListTemplate} />   
                                                    </div>
                                                </div>                                           
                                               
                                                <div className="row">
                                                    <div className="col-sm-6 mt-20"></div>
                                                    <div className="col-sm-6 pt20 btn_rt">                                                   
                                                         <CommonButton type="submit" className="ml_15" primary={true} label= "Save Raw Data"/>                                                    
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        :                                        
                                        <div>
                                            <div className="clearfix"></div>                                        
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandlerSkillAquisitionBehavior.bind(this))} >    
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                    <div className="panel_title">
                                                        <h3>Add Raw {this.state.ClickedTargetType.toUpperCase()} Data</h3>
                                                        <i className="flaticon flaticon-calendar-1"></i>
                                                    </div>
                                                    <FieldArray name="patientSkAcqBehvaiorRawData" component={this.renderRawDataListTemplate} />
                                                    </div>
                                                </div>                                           
                                               
                                                <div className="row">
                                                    <div className="col-sm-6 mt-20"></div>
                                                    <div className="col-sm-6 pt20 btn_rt">                                                   
                                                         <CommonButton type="submit" className="ml_15" primary={true} label= "Save Raw Data"/>                                                    
                                                    </div>
                                                </div>
                                            </form>
                                        </div>      

                                }
                            </div>
                        </div>
                    </div>

            }
        }

        return (
            <div className="readmin-panel">
                <div className="panel-body">                    
                        <Tabs className="custom_tabs">
                            {
                                this.state.domainData.length > 0 &&
                                this.state.domainData.map((obj, index) => {
                                    return <Tab
                                        className="customtab"
                                        key={index}
                                        style={innerTabStyles.tab[index]}
                                        // icon={<FontIcon className="material-icons material-icons-innertabs">local_library</FontIcon>}
                                        onClick={(e) => this.setInnerActive('skill acquisition', `${index}`, obj.domainId, obj.parentDomainId, obj.id, 'onDomainClick')}
                                        value={index}
                                        label={<font>{obj.domainName}</font>}>
                                    </Tab>
                                })
                            }
                        </Tabs>
                        {!this.state.isOnDomainClick && <div style={{ marginTop: '2%', boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px', textAlign: 'center', height: '60px' }}><h4 style={{ paddingTop: '17px' }} className="text-center no-record">{this.state.domainData && this.state.domainData.length > 0 ? 'Please select domain' : 'Please add domain'} </h4></div>}
                        {component}
                    </div>                    
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;       

        return (
            <div>
                {this.props.addPermissionDomain ?
                    <RaisedButton
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                        label="Add Domain"
                        primary={true}
                        onTouchTap={() => this.handleOpen('addDomain')} />
                    : null}
                {this.props.addPermissionDomain ?
                    <RaisedButton
                        style={{ marginLeft: '10px', marginTop: '10px', marginBottom: '10px' }}
                        label="Unarchive"
                        primary={true}
                        onTouchTap={() => this.handleOpen('BatchUnrchiveSkillAcquisition')} />
                    : null}
                {this.renderSkillAquisitionTabs(handleSubmit)}
                {this.state.open && <SkillAquisitionDomainModal
                    skillAcquisitionDomainId={this.state.skillAcquisitionDomainId}
                    masterDomains={this.state.masterDomains}
                    patientId={this.state.patientId}
                    closeDialog={() => this.handleClose('closeDomainModal')} />}
                 
                {this.state.isCurriculumLibraryClicked && <CopyCurriculumLibraryModal
                 programId={this.state.programId}
                 patientId ={this.state.patientId}
                 domainId= {this.state.domainId}
                 closeDialog={() => this.handleClose('closeCopyCurriculumLibrary')}
                />}
                {this.state.isMoveDomainClicked && <MoveDomainModal
                skillAcquisitionDomainId={this.state.skillAcquisitionDomainId}
                domainId= {this.state.domainId}
                patientId ={this.state.patientId}
                closeDialog={() => this.handleClose('closeMoveDomain')}
                />}

                {this.state.openBatchUnarchiveSkillAcquisition && <BatchUnarchiveSkillAcquisitionModal                    
                    patientId={this.state.patientId}
                    closeDialog={() => this.handleClose('closeBatchUnarchiveSkillAcquisitionModal')} />}

                {this.state.openBatchTargetStatusModal && <UpdateBatchTargetStatusModal
                    selectedSkillsAcquisitionTargetIds={this.state.selectedSkillsAcquisitionTargetIds}
                    masterTargetStatusWithoutReady={this.props.masterTargetStatusWithoutReady}
                    patientId={this.state.patientId}
                    skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                    closeDialog={() => this.handleBatchTargetStatusClose('closeDomainModal')}                                       
                    />}

                {this.state.openBatchTargetActiveStatusModal && <UpdateBatchActiveStatusModal
                    selectedSkillsAcquisitionTargetIds={this.state.selectedSkillsAcquisitionTargetIds}
                    selectedSkillsAcquisitionProgramIds={null}
                    domainId = {this.state.domainId}
                    masterTargetStatusWithoutReady={this.props.masterTargetStatusWithoutReady}
                    patientId={this.state.patientId}
                    skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                    targetType={true}
                    programType={false}
                    closeDialog={() => this.handleBatchTargetStatusClose('closeDomainModal')}                                       
                    />}

                {this.state.openBatchProgramActiveStatusModal && <UpdateBatchActiveStatusModal
                    selectedSkillsAcquisitionTargetIds={null}
                    selectedSkillsAcquisitionProgramIds={this.state.selectedSkillsAcquisitionProgramIds}
                    domainId = {this.state.domainId}
                    masterTargetStatusWithoutReady={this.props.masterTargetStatusWithoutReady}
                    patientId={this.state.patientId}
                    skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                    targetType={false}
                    programType={true}
                    closeDialog={() => this.handleBatchTargetStatusClose('closeDomainModal')}                                       
                    />}

            </div>
        )
    }
}

SkillAquisition = reduxForm({
    form: 'SkillAquisitionForm',
    enableReinitialize: true,
})(SkillAquisition);

function mapStateToProps(state) {

    let initialValueData = {
        patientSkillsAcquisitionCollectedRawData: [{}],
        patientSkAcqBehvaiorRawData: [{}],
      };

    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermissionDomain = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_Domain")[0].permission : false;
    let updatePermissionDomain = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_EDIT_DOMAIN")[0].permission : false;
    let deletePermissionDomain = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_DELETE_DOMAIN")[0].permission : false;

    let addPermissionProgram = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_PROGRAM")[0].permission : false;
    let updatePermissionProgram = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_UPDATE_PROGRAM")[0].permission : false;
    // let deletePermissionProgram = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_DELETE_PROGRAM")[0].permission : false;
    let copyPermissionProgram = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_COPY_PROGRAM")[0].permission : false;
    let viewGraphPermissionProgram = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_VIEW_GRAPH_PROGRAM")[0].permission : false;
    let viewTargetPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_VIEW_TARGET")[0].permission : false;


    let addPermissionTarget = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_TARGET")[0].permission : false;
    let updatePermissionTarget = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_UPDATE_TARGET")[0].permission : false;
    // let deletePermissionTarget = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_DELETE_TARGET")[0].permission : false;
    let copyPermissionTarget = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_COPY_TARGET")[0].permission : false;
    let viewGraphPermissionTarget = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_VIEW_GRAPH_TARGET")[0].permission : false;
    let viewRawDataPermissionTarget = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_VIEW_RAW_DATA")[0].permission : false;

    // End For Role Permission

    return {
        loading: state.skillAcquisitionDomain.loading || state.skillAcquisitionProgram.loading || state.skillAcquisitionTarget.loading || state.target.loading,
        skillAcquisitionProgramList: state.skillAcquisitionProgram.skillAcquisitionProgramList,
        skillAcquisitionDomainList: state.skillAcquisitionDomain.skillAcquisitionDomainList,
        skillAcquisitionTargetList: state.skillAcquisitionTarget.skillAcquisitionTargetList,
        saved_skillAcquisitionDomain: state.skillAcquisitionDomain.saved_skillAcquisitionDomain,
        deleted_skillAcquisitionDomain: state.skillAcquisitionDomain.deleted_skillAcquisitionDomain,
        masterDomains: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.masterDomainsWithLibrary : [],
        masterPrograms: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.masterPrograms : [],
        desiredDailyTrials: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.desiredDailyTrials : [],
        masteryType: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.masteryType : [],
        masterTargetStatus: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.targetStatus : [],
        masterTargetStatusWithoutReady: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.targetStatusWithoutReady : [],
        autoOpenOrder: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.autoOpenOrder : [],
        targetType: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.targetType : [],
        responsePercentage: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.responsePercentage : [],
        consecutiveDays: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.consecutiveDays : [],
        firstTrialMustBeIndependent: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.firstTrialMustBeIndependent : [],
        dcMasterMaintenanceLevels: state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.dcMasterMaintenanceLevels : [],
        programListDetailsByDomain: state.program.programListDetailsByDomain,
        addPermissionDomain: addPermissionDomain, //For Role Permission
        updatePermissionDomain: updatePermissionDomain, //For Role Permission
        deletePermissionDomain: deletePermissionDomain, //For Role Permission
        addPermissionProgram: addPermissionProgram, //For Role Permission
        updatePermissionProgram: updatePermissionProgram, //For Role Permission
        //deletePermissionProgram: deletePermissionProgram, //For Role Permission
        copyPermissionProgram: copyPermissionProgram, //For Role Permission
        viewGraphPermissionProgram: viewGraphPermissionProgram, //For Role Permission
        viewTargetPermission: viewTargetPermission, //For Role Permission
        addPermissionTarget: addPermissionTarget, //For Role Permission
        updatePermissionTarget: updatePermissionTarget, //For Role Permission
        //deletePermissionTarget: deletePermissionTarget, //For Role Permission
        copyPermissionTarget: copyPermissionTarget, //For Role Permission
        viewGraphPermissionTarget: viewGraphPermissionTarget, //For Role Permission
        viewRawDataPermissionTarget: viewRawDataPermissionTarget, //For Role Permission
        promptCodeListData: state.patient_prompt_code.promptCodeList !== null ? state.patient_prompt_code.promptCodeList : [],
        allStaffs : state.skillAcquisitionDomain.masterData ? state.skillAcquisitionDomain.masterData.allStaffsActiveAndInactive : [],
        patientSkillAcqTaskAnalysisList: state.patientSkillAcqActiveTarget.patientSkillAcqTaskAnalysisList,
        initialValues: initialValueData,
        archiveBatchDCStatus: state.curriculumLibraries.archiveBatchDCStatus,    
        promptCodeListMastereDTTData: state.patient_prompt_code.promptCodeList !== null && state.patient_prompt_code.promptCodeList.data !== null ? state.patient_prompt_code.promptCodeList.data.filter((op) => op.dtt === true && op.maintenance === true) : [],
        promptCodeListMastereTAData: state.patient_prompt_code.promptCodeList !== null && state.patient_prompt_code.promptCodeList.data !== null ? state.patient_prompt_code.promptCodeList.data.filter((op) => op.ta === true && op.maintenance === true) : [],
        promptCodeListDTTData: state.patient_prompt_code.promptCodeList !== null && state.patient_prompt_code.promptCodeList.data !== null ? state.patient_prompt_code.promptCodeList.data.filter((op) => op.dtt === true) : [],
        promptCodeListTAData: state.patient_prompt_code.promptCodeList !== null && state.patient_prompt_code.promptCodeList.data !== null ? state.patient_prompt_code.promptCodeList.data.filter((op) => op.ta === true) : [],
    }
}

export default connect(mapStateToProps, { getSkillAcquisitionDomainList, deleteSkillAcquisitionTarget, getSkillAcquisitionTargetList, getMasterData, getProgramDetailsByDomain, getSkillAcquisitionProgramList, deleteSkillAcquisitionProgram, updateProgramActiveStatus, copyPatientSkillAcquisitionProgram, updateTargetActiveStatus, deleteSkillAcquisitionDomain, updateTargetStatus, copyPatientSkillAcquisitionTarget,
    clearFieldErrorArray,
    getPromptCodeList,
    saveSkillsAcquisitionRawData,
    getPatientSkillAcqTaskAnalysislist,
    UpdateDCArchiveStatus,
    SaveRawSkillAquisitionBehaviorData,
})(SkillAquisition);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/index.js